<section class="microsoft-callback" aria-live="polite">
  <div *ngIf="isLoading" class="callback-state" aria-label="Processing Microsoft authentication">
    <mat-spinner diameter="32"></mat-spinner>
    <p>{{ 'settings.microsoft.oauth_processing' | translate }}</p>
  </div>

  <div *ngIf="errorMessage && !isLoading" class="alert alert-danger" role="alert">
    <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
    {{ errorMessage }}
  </div>

  <div *ngIf="successMessage && !isLoading" class="alert alert-success" role="status">
    <i class="fas fa-check-circle" aria-hidden="true"></i>
    {{ successMessage }}
  </div>
</section>
